import ChargerModule from 'components/chargerModule';
import DownloadUploadCatalogModule from './DownloadUploadCatalogModule';

export const DownloadUploadCatalog = () => {
  return (
    <ChargerModule
      headerInfo={{
        title: 'Cargue Masivo',
        subtitle: '',
        titleRoute: '/bulk-upload/type-of-charge'
      }}
      infoSideBar={{ position: 'bulkUpload' }}
    >
      <DownloadUploadCatalogModule />
    </ChargerModule>
  );
};
